<input
  style="display: none"
  type="file"
  name="filesInput"
  id="filesInput"
  (change)="uploadFilesChange($event)"
  [multiple]="multiple"
  [accept]="accept"
  #filesInput
/>

<div class="mb-2">
  <button [disabled]="disabled || uploading" class="btn btn-success" (click)="addUploadFile()">
    <fa-icon [icon]="icon"></fa-icon>
    {{buttonText}}
  </button>
</div>

<ng-container *ngIf="uploading || confirm">
  <div class="row my-2" *ngFor="let f of uploadFiles; let i = index">
    <div class="col-sm-8 d-flex align-items-center">
      <button *ngIf="!uploading" (click)="removeUploadFile(f)" class="btn btn-danger me-2">
        <fa-icon [icon]="['fal', 'times']" class="bi" size="lg" [fixedWidth]="true"></fa-icon>
      </button>

      <ngb-progressbar class="w-100" type="success" [value]="uploadProgress[f.title]" [max]="100"></ngb-progressbar>
    </div>

    <div class="col-sm-3 d-flex align-items-center">
      <fa-icon
        *ngIf="uploading && uploadProgress[f.title] !== 100"
        class="bi mx-2"
        icon="spinner"
        [spin]="true"
        size="lg"
        [fixedWidth]="true"
      ></fa-icon>
      <fa-icon *ngIf="uploadProgress[f.title] === 100" class="bi mx-2" icon="check" size="lg" [fixedWidth]="true"></fa-icon>
      <app-button-input
        *ngIf="confirm"
        type="text"
        [initialValue]="f.originalTitle"
        [(value)]="f.title"
        [disabled]="f.title === f.originalTitle"
        (cancel)="f.title = f.originalTitle"
        (apply)="f.originalTitle = f.title"
      ></app-button-input>
      <h5 *ngIf="!confirm">{{ f.title }}</h5>
    </div>
  </div>

  <div class="mb-2" *ngIf="uploadFiles.length">
    <button *ngIf="confirm" [disabled]="uploading || uploadFiles.length === 0" class="btn btn-primary" (click)="startUploading()">
      Upload {{ uploadFiles.length }} {{ uploadFiles.length === 1 ? 'File' : 'Files' }}
    </button>
    <div class="col-sm-12">{{uploadedCount}} / {{uploadFiles.length}} files were successfully uploaded</div>
  </div>
</ng-container>
